var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[_c('img',{attrs:{"src":_vm.$route.query.url,"alt":""},on:{"click":function($event){return _vm.$router.go(-1)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }